import React from 'react';

import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Product } from '../../../../models/product.model';
import { Service } from '../../../../models/service.model';

export interface AppInventoryViewTagsProps {
  record: any | Service | Product
};

const AppInventoryViewTags: React.FunctionComponent<AppInventoryViewTagsProps> = ({record}) => {
  const {lang} = StateLanguage()

  return (
    <div className="card card-flush">
      <div className="card-header">
        <div className="card-title">
          <h5>{lang.labels.tags}</h5>
        </div>
      </div>
      <div className="card-body pt-0">
        { record.tags.length > 0
          ?
          <>
            { record.tags.map (( (item: any, index: number) => { return (
              <div key={index} className={`d-flex align-items-center ${index < record.tags.length - 1 && "pb-1"}`}>
                <span className="bullet bg-primary me-3"></span>
                <span className="fw-bold">{item}</span>
              </div>
            )}))}
          </>
          :
          <div className="text-secondary text-justify">
            {lang.labels.noRecordsFound}
          </div>
        }
      </div>
    </div>
  )
};

export default AppInventoryViewTags;
